import { render, staticRenderFns } from "./FDA_1_Code.vue?vue&type=template&id=16c9b738&"
import script from "./FDA_1_Code.vue?vue&type=script&lang=js&"
export * from "./FDA_1_Code.vue?vue&type=script&lang=js&"
import style0 from "./FDA_1_Code.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports